import React, {useState} from "react";
import {Button, Checkbox, Form, Input} from "antd";

interface ISignUpFormProps {
  onSubmit: (values: any) => Promise<any>;
}

export default function SignUpForm(props: ISignUpFormProps): JSX.Element {
  const [submitting, setSubmitting] = useState(false);
  const [form] = Form.useForm();

  const onFinish = async function (values: any) {
    setSubmitting(true);
    await props.onSubmit(values);
    setSubmitting(false);
  };

  return (
    <Form form={form} onFinish={onFinish} style={{width: 300}}>
      <Form.Item name="name" rules={[{required: true, message: "Please input your name"}]}>
        <Input type="text" placeholder="Full name" size="large" />
      </Form.Item>
      <Form.Item name="email" rules={[{required: true, message: "Please input your email"}]}>
        <Input type="email" placeholder="Email" size="large" />
      </Form.Item>
      <Form.Item
        name="password"
        rules={[
          {required: true, message: "Please input your password"},
          {min: 6, message: "Minimum is 6 characters"},
        ]}
      >
        <Input type="password" placeholder="Password" size="large" />
      </Form.Item>
      <Form.Item
        name="agreement"
        valuePropName="checked"
        rules={[
          {
            validator: (_, value) =>
              value ? Promise.resolve() : Promise.reject(new Error("Please accept the agreement")),
          },
        ]}
      >
        <Checkbox>
          I agree to the{" "}
          <a
            href="https://cantamus.app/s3/cantamus-legal/Cantamus-Terms+of+Use.pdf"
            target="_blank"
            rel="license noreferrer"
            style={{textDecoration: "underline"}}
          >
            terms of use
          </a>{" "}
          and{" "}
          <a
            href="https://cantamus.app/s3/cantamus-legal/Cantamus-Privacy+Policy.pdf"
            target="_blank"
            rel="license noreferrer"
            style={{textDecoration: "underline"}}
          >
            privacy policy.
          </a>
        </Checkbox>
      </Form.Item>
      <Form.Item>
        <Button type="primary" htmlType="submit" loading={submitting} style={{width: "100%"}} size="large">
          Sign up
        </Button>
      </Form.Item>
    </Form>
  );
}
